export default __webpack_public_path__ + "static/media/star.2a91de1b.svg";